import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { ApplicantReportsListingModel } from 'common/models/page-models/reports/applicant-reports/applicant-report-grid-model';
import { ApplicantsReportsModel } from 'common/models/page-models/reports/applicant-reports/applicant-report-data-model';
import { ApplicantReportsGridPostParams } from 'common/models/page-models/reports/applicant-reports/applicant-report-grid-params';
import { ApplicantsChartsModel } from 'common/models/page-models/reports/applicant-reports/applicant-reports-charts.model';
import * as Highcharts from 'highcharts';


@Injectable({
    providedIn: 'root'
})
export class ApplicantsReportsDataService extends GridDataService<ApplicantReportsListingModel, ApplicantsReportsModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.applicationReport, http, ss);
    }

    createInstance(): ApplicantReportsListingModel {
        return new ApplicantReportsListingModel();
    }

    getDeleteUrl() {
        return '';
    }

    getGridParams(param): GridPostParams {
        return new ApplicantReportsGridPostParams();
    }

    override transformDataModel(data: any[], param: any) {
        super.transformDataModel(data, param);
        if (data.hasOwnProperty(param)) {
            //   data[param].forEach(element => {
            //     element.isKT = element.overallKtStatus === 0 ? 'No' : 'Yes';
            //   });
        } else {
            this.ss.showError('No records found for given combination')
        }
        return data;
    }

    override modifyGridPostParams(queryParams) {
        let payload = this.getGridParams(queryParams);
        if (queryParams.transferData !== null) {
            //   payload['batch_search'] = queryParams.transferData.selectedBatch === null ? '' : queryParams.transferData.selectedBatch;
            payload['region_search'] = queryParams.transferData.selectedRegion === null ? '' : queryParams.transferData.selectedRegion;
            payload['branch_search'] = queryParams.transferData.selectedBranch === null ? '' : queryParams.transferData.selectedBranch;
            payload['state_search'] = queryParams.transferData.selectedState === null ? '' : queryParams.transferData.selectedState;
            payload['gender_search'] = queryParams.transferData.selectedGender === null ? '' : queryParams.transferData.selectedGender;
            payload['status_search'] = queryParams.transferData.selectedStatus === null ? '' : queryParams.transferData.selectedStatus;
        }
        return payload;
    }

    override prepareChartsData(apiData) {
        const chartsModel = new ApplicantsChartsModel();
        // let maleCount = 0;
        // let femaleCount = 0;
        // let otherCount = 0;
        let genderCount = {
            maleCount: 0,
            femaleCount: 0,
            otherCount: 0
        }
        let regionCount = {
            eastCount: 0,
            westCount: 0,
            northCount: 0,
            southCount: 0,
        }
        let appliedCount = {
            above40: 0,
            below60: 0,
            below75: 0,
            above75: 0,
            above80: 0
        }
        let deligenceCount = {
            callConnected: 0,
            callNotConnected: 0,
            notReachable: 0,
            switchedOff: 0,
            rescheduled: 0,
            didntAnswer: 0
        }
        let documentationCount = {
            uploaded: 0,
            notUploaded: 0,
            verified: 0
        }
        let assessmentCount = {
            below5: 0,
            below7: 0,
            mark7to8: 0,
            mark8to10: 0,
            above10: 0,
        }
        let homeVisitCount = {
            assets: 0,
            occupation: 0,
            parendEd: 0,
            socialSkills: 0
        }
        let interviewCount = {
            yes: 0,
            no: 0,
            maybe: 0
        }
        let rejectCount = {
            reject: 0,
            nonReject: 0
        }

        apiData.forEach((key) => {
            switch (key.orggender) {
                case 'female':
                    genderCount.femaleCount++;
                    break;
                case 'male':
                    genderCount.maleCount++;
                    break;
                default:
                    genderCount.otherCount++;
                    break;
            }

            switch (key.region) {
                case 'south':
                    regionCount.southCount++;
                    break;
                case 'north':
                    regionCount.northCount++;
                    break;
                case 'east':
                    regionCount.eastCount++;
                    break;
                case 'west':
                    regionCount.westCount++;
                    break;
            }

            if (parseFloat(key.Total) > 40 || parseFloat(key.Total) === 40) {
                appliedCount.above40++;
            } else if (parseFloat(key.Total) < 60) {
                appliedCount.below60++;
            } else if ((parseFloat(key.Total) === 60 || parseFloat(key.Total) > 60) && parseFloat(key.Total) < 75) {
                appliedCount.below75++;
            } else if (parseFloat(key.Total) === 75 || parseFloat(key.Total) > 75 && parseFloat(key.Total) < 80) {
                appliedCount.above75++;
            } else if (parseFloat(key.Total) === 80 || parseFloat(key.Total) > 80) {
                appliedCount.above80++;
            }

            switch (key.callStatus) {
                case 0:
                    deligenceCount.callNotConnected++;
                    break;
                case 1:
                    deligenceCount.callConnected++;
                    break;
                case 2:
                    deligenceCount.notReachable++;
                    break;
                case 3:
                    deligenceCount.switchedOff++;
                    break;
                case 4:
                    deligenceCount.rescheduled++;
                    break;
                case 5:
                    deligenceCount.didntAnswer++;
                    break;
            }

            if (parseInt(key.DocUploadedCount) > 0) {
                documentationCount.uploaded++;
            } else if (parseInt(key.DocUploadedCount) > 0 && parseInt(key.DocVerifiedCount) > 0) {
                documentationCount.verified++;
            } else if (parseInt(key.DocUploadedCount) === 0) {
                documentationCount.notUploaded++;
            }

            switch (key.interviewStatus) {
                case 'Y':
                    interviewCount.yes++;
                    break;
                case 'N':
                    interviewCount.no++;
                    break;
                case 'M':
                    interviewCount.maybe++;
                    break;
            }

            if (parseFloat(key.assessmentMarks) < 5) {
                assessmentCount.below5++;
            } else if (parseFloat(key.assessmentMarks) === 5 || parseFloat(key.assessmentMarks) > 5 && parseFloat(key.assessmentMarks) < 7) {
                assessmentCount.below7++;
            } else if (parseFloat(key.assessmentMarks) === 7 || parseFloat(key.assessmentMarks) > 7 && parseFloat(key.assessmentMarks) < 8) {
                assessmentCount.mark7to8++;
            } else if (parseFloat(key.assessmentMarks) === 8 || parseFloat(key.assessmentMarks) > 8 && parseFloat(key.assessmentMarks) < 10) {
                assessmentCount.mark8to10++;
            } else if (parseFloat(key.assessmentMarks) === 10 || parseFloat(key.assessmentMarks) > 10) {
                assessmentCount.above10++;
            }

            if (key.homeVisitOccupationScore !== null && key.homeVisitOccupationScore !== '' && key.homeVisitOccupationScore !== '0') {
                homeVisitCount.occupation++;
            }
            if (key.homeVisitParentEduScore !== null && key.homeVisitParentEduScore !== '' && key.homeVisitParentEduScore !== '0') {
                homeVisitCount.parendEd++;
            }
            if (key.homeVisitHousingAssetsScore !== null && key.homeVisitHousingAssetsScore !== '' && key.homeVisitHousingAssetsScore !== '0') {
                homeVisitCount.assets++;
            }
            if (key.homeVisitSocialSkillScore !== null && key.homeVisitSocialSkillScore !== '' && key.homeVisitSocialSkillScore !== '0') {
                homeVisitCount.socialSkills++;
            }
            if (key.isRejected === '1') {
                rejectCount.reject++;
            }
        });
        // console.log(apiData.length)
        rejectCount.nonReject = apiData.length - rejectCount.reject;
        // console.log(genderCount, regionCount, appliedCount, deligenceCount, documentationCount, interviewCount, assessmentCount, homeVisitCount, rejectCount)

        chartsModel.regionPieChart.options = {
            chart: {
                type: 'column',
                height: 300,
                width: 500,
            },
            title: {
                text: `Region Wise & Gender Wise Student Distribution <br>Total: ${apiData.length.toString()} Applicants`,
                align: 'left',
                style: {
                    fontSize: '13px', // Adjust the font size as needed
                    fontWeight: 'bold' // Optional: adjust the font weight
                }
            },
            xAxis: {
                categories: ['East', 'West', 'North', 'South'],
                title: {
                    text: null
                }
            },
            yAxis: {
                title: {
                    text: 'Student Count'
                }
            },
            series: [
                {
                    name: 'Student Count',
                    data: [
                        regionCount.eastCount,
                        regionCount.westCount,
                        regionCount.northCount,
                        regionCount.southCount
                    ],
                    color: '#00838d' // Adjust color for column chart
                },
                {
                    name: 'Gender Based',
                    type: 'pie',
                    data: [
                        {
                            name: 'Male',
                            y: genderCount.maleCount
                        },
                        {
                            name: 'Female',
                            y: genderCount.femaleCount
                        },
                        {
                            name: 'Others',
                            y: genderCount.otherCount
                        }
                    ],
                    size: '30%',
                    innerSize: '60%',
                    align: 'center',
                    verticalAlign: 'top',
                    x: 0,
                    y: 0,
                    dataLabels: {
                        enabled: false
                    },
                    colors: ['#a5cec4', '#f0aa98', '#f0c186'] // Adjust colors for pie chart
                }
            ],
            plotOptions: {
                pie: {
                    dataLabels: {
                        enabled: true
                    },
                    center: ['15%', '15%'], // Center donut chart in its allocated area
                }
            }
        };


        chartsModel.appliedScoreChart.options = {
            chart: {
                type: "column",
                height: 300,
                width: 500,
            },
            title: {
                align: "left",
                text: `Applicant Applied Score Analysis <br>Total: ${apiData.length.toString()} Applicants`,
                style: {
                    fontSize: '13px', // Adjust the font size as needed
                    fontWeight: 'bold' // Optional: adjust the font weight
                }
            },
            accessibility: {
                announceNewData: {
                    enabled: true,
                },
            },
            xAxis: {
                type: "category",
                title: {
                    text: "Total Score Analysis",
                },
            },
            yAxis: {
                title: {
                    text: "Count",
                },
            },
            legend: {
                enabled: false,
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: "{y}",
                    },
                },
            },

            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat:
                    '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b><br/>',
            },

            series: [
                {
                    name: "Count",
                    colorByPoint: true,
                    data: [
                        {
                            name: "> 40",
                            y: appliedCount.above40,
                            drilldown: "> 40",
                            color: "#86C8BC",
                        },
                        {
                            name: "40 to 60",
                            y: appliedCount.below60,
                            drilldown: "40 to 60",
                            color: "#CEEDC7",
                        },
                        {
                            name: "60 to 75",
                            y: appliedCount.below75,
                            drilldown: "60 to 75",
                            color: "#FFF6BD",
                        },
                        {
                            name: "75 to 80",
                            y: appliedCount.above75,
                            drilldown: "75 to 80",
                            color: "#FFD4B2",
                        },
                        {
                            name: "> 80",
                            y: appliedCount.above80,
                            drilldown: "> 80",
                            color: "#FFD4B3",
                        }
                    ],
                },
            ],
        };

        const chartData = [
            {
                name: "Not Connected",
                y: deligenceCount.callNotConnected,
                drilldown: "Not Connected",
                color: "#CC7F2B",
            },
            {
                name: "Connected",
                y: deligenceCount.callConnected,
                drilldown: "Connected",
                color: "#9F8416",
            },
            {
                name: "Not Reachable",
                y: deligenceCount.notReachable,
                drilldown: "Not Reachable",
                color: "#71841D",
            },
            {
                name: "Didn't Answer",
                y: deligenceCount.didntAnswer,
                drilldown: "Didn't Answer",
                color: "#408032",
            },
            {
                name: "Switched Off",
                y: deligenceCount.switchedOff,
                drilldown: "Switched Off",
                color: "#006F5F",
            },
        ];

        chartsModel.deligenceCallChart.options = {
            chart: {
                type: 'pie',
                width: 320, // Adjust chart width
                height: 300 // Adjust chart height
            },
            credits: {
                enabled: false // Disable the Highcharts credits
            },
            title: {
                text: 'Total Students:  ' + apiData.length,
                style: {
                    color: '#000000',
                    fontSize: '1.2em',
                }
            },
            series: [
                {
                    type: 'pie', // Add the type property here
                    data: chartData,
                    dataLabels: {
                        enabled: false,
                        inside: true,
                        distance: 6 // Adjust the distance of labels from the slices
                    }
                }
            ]
        };

        chartsModel.deligenceCallChart.data = {
            callNotConnected: deligenceCount.callNotConnected,
            callNotConnectedColor: '#CC7F2B',
            callConnected: deligenceCount.callConnected,
            callConnectedColor: '#9F8416',
            notReachable: deligenceCount.notReachable,
            notReachableColor: '#71841D',
            didntAnswer: deligenceCount.didntAnswer,
            didntAnswerColor: '#408032',
            switchedOff: deligenceCount.switchedOff,
            switchedOffColor: '#006F5F'
        }

        chartsModel.documentationChart.options = {
            chart: {
                type: 'pie',
                height: 300,
                width: 500,
            },
            title: {
                text: null, // Hides the title
            },
            plotOptions: {
                pie: {
                    innerSize: '70%', // Adjusts the inner radius (hole size) of the donut
                    size: '65%',      // Adjusts the size of the pie chart
                    dataLabels: {
                        enabled: true,
                    },
                    center: ['50%', '50%'], // Centers the text within the pie chart
                },
            },
            series: [
                {
                    name: 'Document',
                    type: 'pie',
                    data: [
                        ['Uploaded', documentationCount.uploaded],
                        ['Not Uploaded', documentationCount.notUploaded],
                        ['Verified', documentationCount.verified]
                    ],
                    dataLabels: {
                        enabled: true, // Disable default data labels
                    },
                    colors: ['#f6e1ea', '#F8C4B4', '#bce29e'],
                },
            ],
            subtitle: {
                text: `<div style="text-align: center;">
             <span style="font-size: 20px; font-weight: bold;">${apiData.length.toString()}</span><br>
             <small style="font-size: 11px; color: #666;">Total Applicants</small>
           </div>`, // Display the total count in the center
                align: 'center',
                verticalAlign: 'middle',
                y: 20, // Adjust vertical alignment if needed
                useHTML: true,
                style: {
                    fontSize: '20px',
                    color: '#000', // Customize the color
                },
            },
            // legend: {
            //   enabled: true,
            //   layout: 'horizontal', // Can be 'vertical' as well
            //   align: 'center',      // Aligns the legend to the center
            //   verticalAlign: 'bottom', // Aligns the legend to the bottom
            //   itemStyle: {
            //     fontSize: '12px', // Adjust font size to fit your design
            //   },
            //   itemMarginTop: 5,    // Adjust spacing between items
            //   itemWidth: 100,       // Set the width of the legend item box
            // },
            credits: {
                enabled: false, // Disable credits
            },
        };

        chartsModel.interviewPieChart.options = {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                height: 320,
                width: 500,
            },
            title: {
                text: `Interview Remarks Analysis <br>Total: ${apiData.length.toString()}`,
                align: 'center',
                style: {
                    fontSize: '13px', // Adjust the font size as needed
                    fontWeight: 'bold' // Optional: adjust the font weight
                }
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.0f}</b>'
            },
            accessibility: {
                point: {
                    valueSuffix: ''
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: [{
                name: 'Interview Status',
                colorByPoint: true,
                data: [{
                    name: 'Yes',
                    y: interviewCount.yes,
                    sliced: true,
                    selected: true
                }, {
                    name: 'No',
                    y: interviewCount.no
                }, {
                    name: 'Maybe',
                    y: interviewCount.maybe
                }],
                colors: ['#d4ffea', '#ffd4e5', '#eecbff']
            }]
        };



        chartsModel.assessmentMarksChart.options = {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                width: 330, // Adjust chart width
                height: 310
            },
            title: {
                text: `Applicants Assessment Marks Analysis <br>Total: ${apiData.length.toString()}`,
                align: 'center',
                style: {
                    fontSize: '13px', // Adjust the font size as needed
                    fontWeight: 'bold' // Optional: adjust the font weight
                }
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.0f}</b>'
            },
            accessibility: {
                point: {
                    valueSuffix: ''
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    borderRadius: 5,
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b><br>{point.percentage:.0f}',
                        distance: -50,
                        filter: {
                            property: 'percentage',
                            operator: '>',
                            value: 4
                        }
                    }
                }
            },
            series: [{
                name: 'Score',
                data: [
                    { name: 'below 5', y: assessmentCount.below5 },
                    { name: '5 to 7', y: assessmentCount.below7 },
                    { name: '7 to 8', y: assessmentCount.mark7to8 },
                    { name: '8 to 10', y: assessmentCount.mark8to10 },
                    { name: 'above 10', y: assessmentCount.above10 }
                ],
                colors: ['#005582', '#0086ad', '#00c2c7', '#97ebdb', '#daf8e3']
            }]
        };

        chartsModel.homeVisitChart.options = {
            chart: {
                type: "column",
                height: 300,
                width: 500,
            },
            title: {
                align: "left",
                text: `Applicant Home Visit Documentation Analysis <br>Total: ${apiData.length.toString()}`,
                style: {
                    fontSize: '13px', // Adjust the font size as needed
                    fontWeight: 'bold' // Optional: adjust the font weight
                }
            },
            accessibility: {
                announceNewData: {
                    enabled: true,
                },
            },
            xAxis: {
                type: "category",
                title: {
                    text: "Documentation Type",
                },
            },
            yAxis: {
                title: {
                    text: "Applicant Count",
                },
            },
            legend: {
                enabled: false,
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: "{y}",
                    },
                },
            },

            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat:
                    '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b><br/>',
            },

            series: [
                {
                    name: "Count",
                    colorByPoint: true,
                    data: [
                        {
                            name: "Assets",
                            y: homeVisitCount.assets,
                            drilldown: "Assets",
                            color: "#b7ded2",
                        },
                        {
                            name: "Occupation",
                            y: homeVisitCount.occupation,
                            drilldown: "Occupation",
                            color: "#f6a6b2",
                        },
                        {
                            name: "Parent's Education",
                            y: homeVisitCount.parendEd,
                            drilldown: "Parent's Education",
                            color: "#f7c297",
                        },
                        {
                            name: "Social Skills",
                            y: homeVisitCount.socialSkills,
                            drilldown: "Social Skills",
                            color: "#90d2d8",
                        }
                    ],
                },
            ],
        };

        chartsModel.rejectedChart.options = {
            chart: {
              type: 'pie',
              plotBackgroundColor: null,
              plotBorderWidth: 0,
              plotShadow: false
            },
            title: {
              text: `${apiData.length}<br>Total<br>Applicants`,
              align: 'center',
              verticalAlign: 'middle',
              y: 60,
              style: {
                fontSize: '1.1em'
              }
            },
            tooltip: {
              pointFormat: '<b>{point.name}</b>: {point.y}' // Ensure compatibility for the tooltip
            },
            accessibility: {
              point: {
                valueSuffix: ''
              }
            },
            plotOptions: {
              pie: {
                allowPointSelect: true, // Allows point selection (optional)
                cursor: 'pointer',      // Changes cursor to pointer on hover
                dataLabels: {
                  enabled: true,
                  distance: -50,
                  style: {
                    fontWeight: 'bold',
                    color: 'white'
                  },
                //   formatter: function () {
                //     return `${this.point.name}: ${this.point.y}`; // Properly references `this.point`
                //   }

                formatter: function (this: Highcharts.Point) {
                    return `${this.name}: ${this.y}`; // Access `name` and `y` properties safely
                  }
                },
                startAngle: -90,
                endAngle: 90,
                center: ['50%', '75%'],
                size: '110%'
              }
            },
            series: [
              {
                type: 'pie',
                name: 'Applicant Count',
                innerSize: '50%',
                data: [
                  { name: 'Rejected', y: rejectCount.reject },
                  { name: 'Not Rejected', y: rejectCount.nonReject }
                ],
                colors: ['#f7d0cb', '#e3e4e6'] // Use consistent color assignment
              }
            ]
          };
          



        chartsModel.regionPieChart.data = {
            east: regionCount.eastCount,
            eastColor: '#b5e5b3',
            west: regionCount.westCount,
            westColor: '#cca1c9',
            north: regionCount.northCount,
            northColor: '#f3a0ad',
            south: regionCount.southCount,
            southColor: '#bed1e3',
        }

        return chartsModel;
    }
}
